import { render } from "./RoomsDetailsIPA.vue?vue&type=template&id=109bb496&scoped=true"
import script from "./RoomsDetailsIPA.vue?vue&type=script&lang=js"
export * from "./RoomsDetailsIPA.vue?vue&type=script&lang=js"

import "./RoomsDetailsIPA.vue?vue&type=style&index=0&id=109bb496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109bb496"]])

export default __exports__